import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import globalPaymentModifierService from '../../services/GlobalPaymentModifierService';
import GlobalPaymentModifierEditorTemplate from './GlobalPaymentModifierEditorTemplate';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from '../../util/SnackbarProvider';

const GlobalPaymentModifierEditor = () => {

    const urlParts = window.location.pathname.split('/')
    const id = urlParts[3] === 'create' ? undefined : urlParts[3]

    useTitle([
        {name: 'Globális Fizetési Érték Lista', url: '/dashboard/global-payment-modifiers'},
        {name: 'Érték', url: '/dashboard/global-payment-modifiers/' + id},
    ])

    const {sendAlertMessage} = useSnackbar()
    const [globalPaymentModifier, setGlobalPaymentModifier] = useState(null);
    const [waitingForServer, setWaitingForServer] = useState(false)
    const [message, setMessage] = useState('');

    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return
        globalPaymentModifierService.findById(id)
            .then((response) => setGlobalPaymentModifier((prev) => ({...prev, ...response})))
            .catch(() => sendAlertMessage('Fizetési érték lekérése sikertelen', 'error'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const onChange = (event) => {
        const {name, value} = event.target;
        setGlobalPaymentModifier((prevGlobalPaymentModifier) => ({
            ...prevGlobalPaymentModifier,
            [name]: value,
        }));
    };

    const update = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        globalPaymentModifierService.updateGlobalPaymentModifier(id, globalPaymentModifier)
            .then(() => navigate('/dashboard/global-payment-modifiers'))
            .catch((error) => setMessage(error.message))
            .finally(() => setWaitingForServer(false))
    };

    return (
        <GlobalPaymentModifierEditorTemplate
            {...{id, globalPaymentModifier, message, onChange, update, waitingForServer, navigate}}
        />
    );
};

export default GlobalPaymentModifierEditor;
